/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';

import * as Constants from '../constants';
import { TicketListItemContainer as TicketListItem } from './ticket_list_item.jsx';

export class TicketList extends React.Component {
        static propTypes = {
          tickets: PropTypes.array,
          openedEditors: PropTypes.array,
          header: PropTypes.bool,
          emptyMessage: PropTypes.string,
          noTicketsMessage: PropTypes.string,
          showEmptyMessage: PropTypes.bool,
          haveNoTickets: PropTypes.bool,
          onChange: PropTypes.func,
          onDelete: PropTypes.func,
          onToggleTicketEditor: PropTypes.func
        };

        static defaultProps = {
          tickets: [],
          header: true,
          settings: {},
          openedEditors: [],
          emptyMessage: "Drag tickets here to add to this section",
          noTicketsMessage: "There are no tickets",
          showEmptyMessage: true,
          haveNoTickets: false
        };

        render() {

          // The widths used below must match the widths used in TicketListItem
          const header = this.props.header ?
            <thead key="header">
              <tr>
                <th width="41%">Name</th>
                <th width="13%">Status</th>
                <th width="15%"># Sold</th>
                <th width="20%">Price</th>
                <th width="11%"></th>
              </tr>
            </thead> : undefined;

          const contents = this.props.haveNoTickets ?
            <tbody key="notickets">
              <tr>
                <td colSpan="5">
                  <a href="#" onClick={this.props.onAddTicketClass}>Create your first ticket</a>
                </td>
              </tr>
            </tbody>
          : this.props.tickets.length === 0 ?
            <tbody key="notickets">
              <tr>
                <td colSpan="5">{this.props.showEmptyMessage && this.props.emptyMessage}</td>
              </tr>
            </tbody>
          :
            Array.from(this.props.tickets).map((ticket) =>
              <TicketListItem key={ticket.id}
                               debug={this.props.debug}
                               ticket={ticket}
                               editorOpened={this.props.openedEditors.indexOf(ticket.id) > -1}
                               settings={this.props.settings}
                               onChange={this.props.onChange}
                               onDelete={this.props.onDelete}
                               onToggleTicketEditor={this.props.onToggleTicketEditor}
                               onDragStart={this.props.onDragStart}
                               onDragFinish={this.props.onDragFinish}
                               onDragCancel={this.props.onDragCancel}
                               onDragUpdate={this.props.onDragUpdate} />);

          return this.props.connectGroupDragPreview(<table className="form-item-list nospace">
            {header}
            {this.props.groupHeader}
            {contents}
          </table>
          );
        }
}

